<div class="upperSection">
  <div class="menuTitle">
    <div class="title">Admin Tools</div>
  </div>
</div>
<div class="middleSection noFlex">
  <perfect-scrollbar>
    @if (isPermUser) {
      <ins-expansion-box [titleHeight]="'auto'"
        [elementOnPanel]="true" [leftPositionedArrow]="true" [titleStyle]="{margin: '4px 0', 'align-items': 'flex-end'}">
        <div titleContent style="white-space: normal">Users</div>
        <div content class="expansionEntries">
          <div (click)="openUserManagement()">User Management</div>
          @if (isPermRole) {
            <div (click)="openRoleManagement()">Role Management</div>
          }
          @if (isActivityReportPerm) {
            <div (click)="openActivityReport()">Activity Report</div>
          }
          <div (click)="exportUsersAccessRight()">Access Rights</div>
          <div style="padding: 0"></div>
        </div>
      </ins-expansion-box>
    }
    @if (enableFunctionalities) {
      <ins-expansion-box [titleHeight]="'auto'"
        [elementOnPanel]="true" [leftPositionedArrow]="true" [titleStyle]="{margin: '4px 0', 'align-items': 'flex-end'}">
        <div titleContent style="white-space: normal">Tour</div>
        @if (isPermTour) {
          <div content class="expansionEntries">
            @if (isPermCreateTour) {
              <div (click)="openImportTour()">Create Tour</div>
            }
            @if (isPermTourManager) {
              <div style="margin-bottom: 16px" (click)="openTourManagement()">Tour Management</div>
            }
          </div>
        }
      </ins-expansion-box>
    }
    @if (isAdmin || isPermImport) {
      <ins-expansion-box [titleHeight]="'auto'"
        [elementOnPanel]="true" [leftPositionedArrow]="true" [titleStyle]="{margin: '4px 0', 'align-items': 'flex-end'}">
        <div titleContent style="white-space: normal">Import</div>
        <div content class="expansionEntries">
          @if (isPermImport) {
            <div (click)="openImportZonesLayers()">Import Zones and Layers</div>
          }
          @if (isPermImport) {
            <div (click)="openImportObjects()">Import Objects</div>
          }
          @if (!(limitedAccess$ | async).disableImportScans && isPermImport) {
            <div (click)="openImportScans()">Import Scans</div>
          }
          @if (isPermImport) {
            <div (click)="openImportE57()" style="margin-bottom: 16px">Import E57</div>
          }
        </div>
      </ins-expansion-box>
    }
    @if (isPermExport && enableFunctionalities) {
      <ins-expansion-box [titleHeight]="'auto'"
        [elementOnPanel]="true" [leftPositionedArrow]="true" [titleStyle]="{margin: '4px 0', 'align-items': 'flex-end'}">
        <div titleContent style="white-space: normal">Export</div>
        <div content class="expansionEntries">
          <div (click)="openExportService(_EXPORT_TYPE.ALL)">All</div>
          <div (click)="openExportService(_EXPORT_TYPE.PLACEMARKS)">Placemarks</div>
          <div (click)="openExportService(_EXPORT_TYPE.ADDRESSES)">Addresses</div>
          <div (click)="openExportService(_EXPORT_TYPE.PANORAMIC)">Panoramic Images</div>
          <div (click)="openExportService(_EXPORT_TYPE.MODELS)">Models</div>
          <div  (click)="openExportService(_EXPORT_TYPE.IMAGES)">Images</div>
          <div  (click)="openExportService(_EXPORT_TYPE.ZONES_LAYERS)" style="margin-bottom: 16px">Zones and Layers</div>
        </div>
      </ins-expansion-box>
    }

    <!-- <div *ngIf="isPermImport" class="outerEntry1 first" (click)="openImportObjects()">
    <mat-icon class="lineIcon" svgIcon="import.obj"></mat-icon>
    Import Objects
  </div> -->
  @if (!(limitedAccess$ | async).disableTemplateManagement && isPermTemplate) {
    <div class="outerEntry1 first" (click)="openTemplateManagement()">
      <mat-icon class="lineIcon1" svgIcon="template.management"></mat-icon>
      Template Management
    </div>
  }


</perfect-scrollbar>
</div>
<div class="bottomAlignedPanelFooter"></div>
